<template>
  <CafeteriaElistmentForm :typeEndPoint="'cafeteriaElistmentForm'" :dataParams="{}"/>
</template>
<script>
import CafeteriaElistmentForm from '@/components/modules/cafeteria/enlistment/form'
export default {
  name: 'CafeteriaElistmentCreate',
  components: {
    CafeteriaElistmentForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/enlistment/create.vue